import { render, staticRenderFns } from "./PdfDocumentViewer.vue?vue&type=template&id=c4577550&scoped=true"
import script from "./PdfDocumentViewer.vue?vue&type=script&lang=js"
export * from "./PdfDocumentViewer.vue?vue&type=script&lang=js"
import style0 from "./PdfDocumentViewer.vue?vue&type=style&index=0&id=c4577550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4577550",
  null
  
)

export default component.exports